/* Common Imports */

import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Data Imports */

import { Typography } from "@material-ui/core";
import AppConfig from "../../../../AppConfig";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  iconImage: {
    height: 56,
    width: 56,
  },
  iconTextRow: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "100%",
    background: "#ffffff",
    gap: "1rem",
    height: "160px",
    padding: "1rem 1rem 1.5rem 1rem",
    boxShadow: "0px 4px 18px 0px rgba(0, 0, 0, 0.05)",
    borderRadius: "1rem",
    border: "1px solid  rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("xs")]: {
      gap: "1rem",
    },
  },
  text: {
    display: "flex",
    flexDirection: "column",
    alignItems: "space-between",
    justifyContent: "flex-start",
  },
  heading: {
    fontWeight: 400,
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    color: "#666666",
    width: "100%",

  },
  subHeading: {
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    color: "#666666",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      wordBreak: "break-word",
    },
  },
  maincontainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "1rem",
    margin: "2rem 0rem 2rem 0rem",
    padding: "0rem 1rem 0rem 1rem",
    // [theme.breakpoints.down("sm")]: {
    //   margin: "16rem 0rem 0rem 0rem",
    //   padding: "0rem 1.5rem 0rem 1.5rem",
    // },
    // [theme.breakpoints.only("xs")]: {
    //   margin: "15rem 0rem 0rem 0rem",
    //   padding: "0rem 1.5rem 0rem 1.5rem",
    // },
    // [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
    //   margin: "16rem 0rem 0rem 0rem",
    // },
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
}));

const ProjectDeatilsMobileCard = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.maincontainer}>
        <div className={`${classes.iconTextRow} ${props.className}`}>
          <img
            alt={AppConfig.imageAltText}
            loading="lazy"
            referrerPolicy="no-referrer"
            height={40}
            width={40}
            src={"/images/icons/heavie/halcyon/landarea.png"}
            className={classes.iconImage}
          />

          <Typography
            variant="body2"
            component="span"
            className={classes.heading}
          >
            34,501 Sqft Land area
          </Typography>
        </div>
        <div className={`${classes.iconTextRow} ${props.className}`}>
          <img
            alt={AppConfig.imageAltText}
            loading="lazy"
            referrerPolicy="no-referrer"
            height={40}
            width={40}
            src={"/images/icons/heavie/halcyon/project_approval.png"}
            className={classes.iconImage}
          />

          <Typography
            variant="body2"
            component="span"
            className={classes.heading}
          >
            BBMP Approved
          </Typography>
        </div>
        <div className={`${classes.iconTextRow} ${props.className}`}>
          <img
            alt={AppConfig.imageAltText}
            loading="lazy"
            referrerPolicy="no-referrer"
            height={40}
            width={40}
            src={"/images/icons/heavie/halcyon/spacious.png"}
            className={classes.iconImage}
          />

          <Typography
            variant="body2"
            component="span"
            className={classes.heading}
          >
            42 Units
          </Typography>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProjectDeatilsMobileCard;
